/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".ProductItem").forEach(function (product) {
        let defaultPrice = product.querySelector(".default-price-container");
        let variantPrice = product.querySelector(".variant-price-container");

        if (defaultPrice && variantPrice) {
            product.addEventListener("mouseenter", function () {
                defaultPrice.style.opacity = "0";
                variantPrice.style.opacity = "1";
                setTimeout(() => {
                    defaultPrice.style.display = "none";
                    variantPrice.style.display = "block";
                }, 200); // Small delay for smooth transition
            });

            product.addEventListener("mouseleave", function () {
                variantPrice.style.opacity = "0";
                defaultPrice.style.opacity = "1";
                setTimeout(() => {
                    variantPrice.style.display = "none";
                    defaultPrice.style.display = "block";
                }, 200);
            });
        }
    });
});




